import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _styled from "styled-components";
var _excluded = ["background", "isOpen", "testId"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { animated, config, useSpring } from '@react-spring/web';
import { NavigationButton } from '../../../';
import { jsx as _jsx } from "react/jsx-runtime";
export var HamburgerComponent = function HamburgerComponent(_ref) {
  var background = _ref.background,
      isOpen = _ref.isOpen,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, _excluded);

  var iconAnimation = useSpring({
    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
    config: config["default"]
  });
  return /*#__PURE__*/_jsx(NavigationButton, _objectSpread(_objectSpread({}, _objectSpread({
    as: 'button'
  }, rest)), {}, {
    twStyle: background === 'white' ? {
      "--tw-text-opacity": "1",
      "color": "rgb(28 19 39 / var(--tw-text-opacity))"
    } : {
      "--tw-text-opacity": "1",
      "color": "rgb(255 255 255 / var(--tw-text-opacity))"
    },
    isDropdownItem: true,
    noPadding: true,
    testId: "hamburger-button",
    children: /*#__PURE__*/_jsx(animated.div, {
      style: iconAnimation,
      children: !isOpen ? /*#__PURE__*/_jsx(_StyledBars3Icon, {}) : /*#__PURE__*/_jsx(_StyledXMarkIcon, {})
    })
  }));
};
export default HamburgerComponent;

var _StyledBars3Icon = /*#__PURE__*/_styled(Bars3Icon).withConfig({
  displayName: "hamburger-component___StyledBars3Icon",
  componentId: "sc-1x9rbxs-0"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "minWidth": "24px"
});

var _StyledXMarkIcon = /*#__PURE__*/_styled(XMarkIcon).withConfig({
  displayName: "hamburger-component___StyledXMarkIcon",
  componentId: "sc-1x9rbxs-1"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "minWidth": "24px"
});